import { useQueryWithUserId } from '@northladder/services';

import { TENANT_CONFIG_API } from '../tenantClient';
import type { IUseTenantListQueryPayload } from '../types';

/**
 * This is to track the device categories from the backend.
 */
const TENANT_DETAILS_QUERY = 'tenant-details-query';

/**
 * This hook fetches a list of device category id and name.
 * These category ids and names are mapped in the step-3 `TradeInDeviceDropdown`
 * component.
 */
export const useTenantListQuery = (payload?: IUseTenantListQueryPayload) => {
  const { data, isError, error, isPending, isFetching, refetch } =
    useQueryWithUserId({
      queryKey: [TENANT_DETAILS_QUERY, payload],
      networkMode: 'always',
      queryFn: () => TENANT_CONFIG_API.fetchTenantList(payload),
    });

  return {
    data,
    error,
    isError,
    isFetching,
    isPending,
    refetchTenantsList: refetch,
  };
};
